














import { defineComponent, PropType, ref, computed } from '@vue/composition-api'

import InputCheckbox from '@/components/atoms/InputCheckbox.vue'
import OutputConditionRowLayout from '@/components/organisms/h/layout/OutputConditionRowLayout.vue'
import {
  checkboxOption,
  emitOutputConditionEach,
  outputCondUseInfo,
} from '@/types/entities'
import { OUTPUT_COND_DELETE } from '@/utils/constant'

export default defineComponent({
  components: {
    OutputConditionRowLayout,
    InputCheckbox,
  },
  props: {
    outputCondUseInfo: {
      type: Object as PropType<outputCondUseInfo>,
      default: () => ({
        outputCondType: 'Delete',
        displayItems: [],
        defaultSelected: [],
        disabledOptions: [],
      }),
      deep: true,
    },
  },
  setup(props, context) {
    const options = ref<checkboxOption[]>([
      {
        text: '削除済みデータを含めて出力する',
        value: OUTPUT_COND_DELETE.includeDelete,
        disabled: false,
      },
    ])

    const useOptions = computed(() => {
      // 使用する項目だけ表示
      const info = props.outputCondUseInfo
      let ret = options.value.filter((elem, index, self) => {
        return info?.displayItems.includes(elem.value)
      })
      // disabledの適用
      ret = ret.map((elem) => {
        let ret = elem
        if (info.disabledItems.includes(elem.value)) {
          ret.disabled = true
        }
        return ret
      })
      return ret
    })

    const selected = ref<string[]>([''])

    /*********************************
     * 以下は出力条件変更時の処理
     *********************************/
    const changeOutputCondition = (val: string[]) => {
      selected.value = val
      const params: emitOutputConditionEach = {
        outputCondType: 'Delete',
        selected: val,
      }
      context.emit('change-output-condition', params)
    }

    return { useOptions, changeOutputCondition }
  },
})
